module.exports = __webpack_public_path__ + "static/media/edit_icon.8b385ee8.svg";